/**
 * Инициализирует Telegram Web App с правильными настройками цветов
 * для корректного отображения текста
 */
export const initTelegramWebApp = () => {
  // Проверяем наличие Telegram Web App
  if (typeof window === 'undefined' || !window.Telegram?.WebApp) {
    return;
  }

  const tg = window.Telegram.WebApp;

  try {
    // Настраиваем цвета для правильного отображения текста
    if (tg.setHeaderColor) {
      tg.setHeaderColor("#ffffff");
    }
    if (tg.setBackgroundColor) {
      tg.setBackgroundColor("#f5f5f5");
    }
    
    // Включаем подтверждение закрытия (если доступно)
    if (tg.enableClosingConfirmation) {
      tg.enableClosingConfirmation();
    }
    
    // Раскрываем приложение на весь экран (если доступно)
    if (tg.expand) {
      tg.expand();
    }
    
    // Готовим приложение к работе (если доступно)
    if (tg.ready) {
      tg.ready();
    }
  } catch (error) {
    console.error("Error initializing Telegram Web App:", error);
  }
};

